import React from 'react';
import './Style/ReportQuestionDetails.css';
import Latex from 'react-latex';
import AllQuestions from '../AllData/AllQuestions';
import { useParams } from 'react-router-dom';

const ReportQuestionDetails = () => {
    const { id,  displayId, message } = useParams();

    const questionData = AllQuestions.find(submission => submission._id.$oid === id);

    if (!questionData) {
        return (
            <div className="error-container">
                <div className="error-msg">⚠️ Question not found. Please check the ID.</div>
            </div>
        );
    }

    const renderWithLatex = (text) => {
        if (!text) return null;
        return (text.includes('$') || text.includes('\\')) ? <Latex>{text}</Latex> : text;
    };

    const getOptionClass = (optionKey) => {
        return questionData.answer === optionKey ? "option-item correct" : "option-item";
    };

    return (
        <div className="report-container">
            {/* 1. Metadata Row */}
            <div className="meta-info-row">
                <div className="meta-item">
                    <span className="meta-label">Type</span>
                    <span className="meta-value">{questionData.type}</span>
                </div>
                <div className="meta-item">
                    <span className="meta-label">Subject</span>
                    <span className="meta-value">{questionData.subject}</span>
                </div>
                <div className="meta-item">
                    <span className="meta-label">Topic</span>
                    <span className="meta-value">{questionData.topic}</span>
                </div>
                <div className="meta-item">
                    <span className="meta-label">Year</span>
                    <span className="meta-value">{questionData.year || 'N/A'}</span>
                </div>
                <div className="meta-item">
                    <span className="meta-label">Q_No</span>
                    <span className="meta-value">{  displayId || 'N/A'}</span>
                </div>
                <div className="meta-item q-no-highlight">
                    <span className="meta-label">No:</span>
                    <span className="meta-value">{questionData.no}</span>
                </div>
                <div className="meta-item q-no-highlight">
                    <span className="meta-label">ID:</span>
                    <span className="meta-value">
                        {questionData.question_img?.replace(/\.png$/, "")}
                    </span>
                </div>
                <div className="meta-item q-no-highlight">
                    <span className="meta-label">Issue:</span>
                    <span className="meta-value">{message}</span>
                </div>
            </div>

            {/* 2. Main Question Card */}
            <div className="question-card">
                {questionData.question_img && (
                    <div className="question-image-container">
                        <img
                            src={`/questionsPhoto/${questionData.question_img}`}
                            alt="Question"
                            className="question-images"
                        />
                    </div>
                )}



                <div className="options-grid">
                    {[
                        { key: 'option1', label: 'A' },
                        { key: 'option2', label: 'B' },
                        { key: 'option3', label: 'C' },
                        { key: 'option4', label: 'D' }
                    ].map((opt) => (
                        <div key={opt.key} className={getOptionClass(opt.key)}>
                            <span className="opt-prefix">{opt.label}</span>
                            <div className="opt-text">{renderWithLatex(questionData[opt.key])}</div>
                        </div>
                    ))}
                </div>



                <div className="question-body">
                    {renderWithLatex(questionData.question_img)}
                </div>

            </div>



            {/* 3. Solution Section */}
            <div className="solution-details">
                <div className="solution-header">
                    <span className="sol-icon">💡</span>
                    <h3>Step-by-Step Solution</h3>
                </div>

                <div className="solution-content">
                    {questionData.solutionimg ? (
                        <div className="sol-img-container">
                            <img
                                src={`/solutionsimg/${questionData.solutionimg}.png`}
                                alt="Solution Explanation"
                                className="question-img-solution"
                            />
                        </div>
                    ) : (
                        <div className="text-solution">
                            {renderWithLatex(questionData.solution) || "No written solution available."}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ReportQuestionDetails;